import * as api from '../../api/api-visar-provision';
import {
    GET_CONFIG_FORM44,
    GET_DATOS_GESTION_IMPLICADO_VISA,
    GET_COMBO_INSTANCIAS_PROVISIONES_VISA,
    GET_PROVISIONES_VIGENTES_VISA,
    GET_COMBO_MONEDAS_VISA,
    GET_COBERTURA_POLIZA_VISA,
    GET_PROVISIONES_IMPLICADOS_VISA,
    GET_HISTORIAL_PROVISIONES_IMPLICADO_VISA,
    GET_COMBO_RESPONSABILIDAD_ASEGURADO,
    GET_AMPAROS_CIA,
    GET_RESERVA_CIA,
    GET_COMBO_DECISION_CIA
} from '../types';

export const configuracionFormAction44 = (query) => ({
    type: GET_CONFIG_FORM44,
    payload: api.getConfiguracionForm44(query)
});
export const obtenerDatosGestionImplicado = (query) => ({
    type: GET_DATOS_GESTION_IMPLICADO_VISA,
    payload: api.getDatosGestionImpicado(query)
});
export const obtenerComboInstanciaProvisiones = (query) => ({
    type: GET_COMBO_INSTANCIAS_PROVISIONES_VISA,
    payload: api.getComboInstanciaProvisiones(query)
});
export const obtenerComboMonedas = (query) => ({
    type: GET_COMBO_MONEDAS_VISA,
    payload: api.getComboMonedas(query)
});
export const obtenerProvisionesVigentes = (query) => ({
    type: GET_PROVISIONES_VIGENTES_VISA,
    payload: api.getProvisionesVigentes(query)
});
export const obtenerCoberturaPoliza = (query) => ({
    type: GET_COBERTURA_POLIZA_VISA,
    payload: api.getCoberturaPoliza(query)
});
export const obtenerProvisionesImplicados = (query) => ({
    type: GET_PROVISIONES_IMPLICADOS_VISA,
    payload: api.getGrillaProvisionesImplicados(query)
});
export const obtenerProvImplicadosHistorial = (query) => ({
    type: GET_HISTORIAL_PROVISIONES_IMPLICADO_VISA,
    payload: api.getGrillaHistorialProvisionesImplicado(query)
});
export const obtenerComboResponsabilidadAsegurado = (query) => ({
    type: GET_COMBO_RESPONSABILIDAD_ASEGURADO,
    payload: api.getComboResponsabilidadAsegurado(query)
});
export const obtenerAmparosCia = (query) => ({
    type: GET_AMPAROS_CIA,
    payload: api.getAmparosCia(query)
});
export const obtenerReservaCia = (query) => ({
    type: GET_RESERVA_CIA,
    payload: api.getReservaCia(query)
});
export const obtenerComboDecisionCia = (query) => ({
    type: GET_COMBO_DECISION_CIA,
    payload: api.getComboDecisionCia(query)
});